module.exports = __webpack_public_path__ + "static/img/qingtian.dcf62033.png";